<script lang="ts">
  import Button from "./Button.svelte";
  import { CheckSmall, File, Copy } from "../icons/index.js";

  interface Props {
    code: string;
    copyable?: boolean;
    filename?: string;
    size?: "sm" | "md";
  }

  let { code, copyable = true, filename = "", size = "md" }: Props = $props();

  let showSuccess = $state(false);

  function copyToClipboard() {
    navigator.clipboard.writeText(code);

    showSuccess = true;

    setTimeout(() => {
      showSuccess = false;
    }, 1000);
  }
</script>

<div class="overflow-hidden rounded-2xl bg-mono-000 shadow-border-inset">
  {#if filename}
    <div
      class="flex h-9 items-center justify-between gap-4 border-b border-b-border bg-mono-100 py-2 pr-1.5 pl-2.5"
    >
      <div class="flex items-center gap-1.5">
        <File class="text-subtle" aria-hidden="true" />
        <span class="text-sm text-foreground-secondary">{filename}</span>
      </div>
      {#if copyable}
        <Button variant="tertiary" size="sm" class="!h-6 !px-2 !py-1" onclick={copyToClipboard}>
          <div class="flex items-center gap-1">
            {#if showSuccess}
              <CheckSmall aria-hidden="true" />
            {:else}
              <Copy aria-hidden="true" class="text-subtle" />
            {/if}
            Copy
          </div>
        </Button>
      {/if}
    </div>
  {/if}

  <div class="wrapper {size} relative overflow-auto">
    {#if copyable && !filename}
      <div class="absolute top-0 right-0 z-10 rounded-bl-lg bg-mono-000 py-1.5 pr-2 pb-1.5 pl-2.5">
        <Button variant="tertiary" size="sm" class="!h-6 !px-2 !py-1" onclick={copyToClipboard}>
          <div class="flex items-center gap-1">
            {#if showSuccess}
              <CheckSmall aria-hidden="true" />
            {:else}
              <Copy aria-hidden="true" class="text-subtle" />
            {/if}
            Copy
          </div>
        </Button>
      </div>
    {/if}
    <code class="block overflow-auto text-xs text-foreground-secondary">
      <pre class="overflow-auto px-3 py-2">{code}</pre>
    </code>
  </div>
</div>

<style>
  @reference "#tailwind.css";
  .wrapper {
    &.default {
      max-height: 320px;
    }

    &.sm {
      max-height: 120px;
    }

    &.md {
      max-height: 320px;
    }
  }
</style>
